import FilteredCar from "./FilteredCar";

const FindCar = () => {
	let heading =
		window.location.pathname === "/find_car"
			? "Market Value List"
			: "Find Salvage Cars";
	const filteredCarProps = {
		heading,
		pageType:
			window.location.pathname === "/find_car" ? "MarketCars" : "SalvageCars",
	};
	return (
		<>
			<FilteredCar {...filteredCarProps} />
		</>
	);
};

export default FindCar;
